import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center mt-2" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Debitor Oplysninger")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldsComponent = _resolveComponent("FieldsComponent")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_4,
        _createVNode(_component_FieldsComponent, {
          modelValue: _ctx.fields,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fields) = $event)),
          "onUpdate:value": _ctx.valueChanged,
          "onUpdate:error": _ctx.errorChanged
        }, null, 8, ["modelValue", "onUpdate:value", "onUpdate:error"])
      ], 64))
}